import React, {useEffect, useState} from "react";
import { IconButton } from "@material-ui/core";
import { ArrowForward } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

const ModuleLink = (props) => {
    let moduleType = props.type
    let moduleName = props.name
    let link = props.destination

    console.log(props.elements)
    let count = props.elements && (props.elements.length || Object.keys(props.elements).length) || 0

    let history = useHistory();
    
    let classList = "module-link " + moduleType
    return <div className={classList} onClick={() => {history.push(link)}}>
        <div className="module-info">
            <div className="module-header">
                {moduleName}
            </div>
            <div className="module-count">
                Item Count: {count}
            </div>
        </div>
        <div className="module-go">
            <IconButton 
						variant="contained" 
						color="primary"
						aria-label={"Go to the " + moduleName + " module" }

						onClick={() => {
							history.push(link)
					}}>
						<ArrowForward />
			</IconButton>
        </div>
    </div>
}

export default ModuleLink;